import { store } from './app/store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import "./index.scss"
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import ruRU from "antd/lib/locale/ru_RU";
import moment from "moment";
import 'moment/locale/ru';
moment.locale("ru");


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ConfigProvider locale={ruRU}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider >,
);

reportWebVitals();
